<script setup>
import { useRoute } from 'vue-router'
import HeadlineFraunces from '@/design/primitives/HeadlineFraunces.vue'
const route = useRoute()
</script>

<template>
  <section class="stub">
    <HeadlineFraunces level="h1">Coming <em>soon</em></HeadlineFraunces>
    <p>Route <code>{{ route.path }}</code> is being built.</p>
  </section>
</template>

<style scoped>
.stub {
  max-width: var(--container-narrow);
  margin: 0 auto;
  padding: var(--sp-32) var(--sp-6);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  color: var(--ink);
}
.stub p { color: var(--ink-soft); }
.stub code { font-family: var(--font-mono); color: var(--gold); }
</style>
